// src/pages/BranchLedger/BranchLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBranchLedgerApi } from "../../../apiservice/reports";
import { getBranchApi } from "../../../apiservice/setting";

export const fetchBranchLedger = createAsyncThunk(
  "branchLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        branchId: filters?.branchId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getBranchLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchBranches = createAsyncThunk(
  "branchLedger/fetchBranches",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getBranchApi({ "without-self": "yes" });
      return res.data.message || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
